import type React from 'react';

import PageBackButton from './components/PageBackButton';
import PageBody from './components/PageBody';
import PageFilters from './components/PageFilters';
import PageFooter from './components/PageFooter';
import PageHeader from './components/PageHeader';
import PageTabs from './components/PageTabs';

export interface PageProps {
  children: React.ReactNode;
}

const Page = ({ children }: PageProps) => {
  return <div className='min-h-full bg-white space-y-5 p-5 mb-16'>{children}</div>;
};

Page.BackButton = PageBackButton;
Page.Header = PageHeader;
Page.HeaderTitle = PageHeader.Title;
Page.HeaderActions = PageHeader.Actions;
Page.Filters = PageFilters;
Page.Tabs = PageTabs;
Page.Body = PageBody;
Page.Footer = PageFooter;

export default Page;
